/**
 * Created by bootdo.
 * 角色相关api
 */
import * as API from '.'
import $const from '../common/constant'

export default {

  //根据parentCode 获取树形部门列表
  findList: params => {
    return API.GET($const.apiServer.CMS+'/employee/list', params);
  },
  queryList: params => {
    return API.GET($const.apiServer.CMS+'/employee/queryList', params);
  },
  findAllList: params => {
    return API.GET($const.apiServer.CMS+'/employee/allList', params);
  },
  add: params => {
    return API.POST($const.apiServer.CMS+'/employee/add',params);
  },
  update: params => {
    return API.POST($const.apiServer.CMS+'/employee/update',params);
  },
  save: (params,config) => {
    return API.POST($const.apiServer.CMS+'/employee/save',params,config);
  },
  remove:params => {
    return API.GET($const.apiServer.CMS+'/employee/remove',params);
  },
  getPhotoUrl:params => {
    return API.GET($const.apiServer.CMS+'/employee/getPhotoUrl',params);
  },
  getJobNumber:params => {
    return API.GET($const.apiServer.CMS+'/employee/getJobNumber',params);
  },
  getUserExt: params => {
    return API.GET($const.apiServer.CMS+'/employee/getUserExt', params);
  },
  getEmployeeList:params => {
    return API.GET($const.apiServer.CMS+'/employee/getEmployeeList',params)
  },
}



// WEBPACK FOOTER //
// ./src/api/api_employee.js